module.exports = __webpack_public_path__ + "img/east-wow-logo.9c3beefb.jpg";